import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-faqs',
  templateUrl: './add-faqs.component.html',
  styleUrls: ['./add-faqs.component.scss']
})
export class AddFaqsComponent implements OnInit {

formData: any = {
 question_ar: '',
  question_en: '',
  answer_ar: '',
  answer_en: ''
};
 
 
  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private translate: TranslateService
  ) {}

    ngOnInit(): void {
  
    }
 
  onFileSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.image = event.target.files[0];
  }
}
    cancel(): void {
      this.router.navigate(['/frequently']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit(): void {
  const form = new FormData();
  form.append('question_ar', this.formData.question_ar);
  form.append('question_en', this.formData.question_en);
  form.append('answer_ar', this.formData.answer_ar);
  form.append('answer_en', this.formData.answer_en);

  this.apisService.addFaq(form).subscribe({
    next: () => {
      this.toastr.success(this.translate.instant('MENU.DASHBOARD.faq_added_successfully'));
      this.router.navigate(['/frequently']);
    },
    error: (error: any) => {
      console.error('Error adding FAQ:', error);

      if (error.error?.errors) {
        const e = error.error.errors;

        if (e.question_ar) this.toastr.error(e.question_ar[0]);
        if (e.question_en) this.toastr.error(e.question_en[0]);
        if (e.answer_ar) this.toastr.error(e.answer_ar[0]);
        if (e.answer_en) this.toastr.error(e.answer_en[0]);
      } else {
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.something_went_wrong'));
      }
    }
  });
}


}